import React from 'react';
import styles from './ActionProgressSuccess.module.css';
import useTheme from 'config/useTheme';

const ActionProgressSuccess = ({ message, onClose }) => {
    const { dark } = useTheme();
    return (
        <div className={`${styles.action_progress} ${dark ? styles.dark : ''}`}>
            <div className={styles.top_bar}>
                <button onClick={() => onClose()}>Close</button>
            </div>
            <div className={styles.main}>
                <div className={styles.bar}>
                    <div className={styles.label}>100%</div>
                </div>
                {message && <span>{message}</span>}
            </div>
        </div>
    )
}

export default ActionProgressSuccess;